<template>
  <div>
    <div class="form-group mb-4">
      <p>
        ¿El proyecto contempla el uso de materiales peligrosos: Corrosivos, Reactivos, Explosivos,
        Tóxicos, Inflamables (CRETI)?
      </p>
      
      <!-- Question 11 -->
      <div class="form-check form-check-inline">
        <input id="question-11-radio-1" :checked="questionnaire.question_11"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-11-collapse:not(.show)" data-toggle="collapse"
               name="question_11"
               type="radio"
               value="1"
               @change="addValidation('question_11')">
        <label class="form-check-label"
               for="question-11-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-11-radio-2" :checked="questionnaire.question_11 === false"
               class="form-check-input"
               data-target=".question-11-collapse.show" data-toggle="collapse" name="question_11"
               type="radio"
               value=""
               @change="removeValidation('question_11')">
        <label class="form-check-label"
               for="question-11-radio-2">No</label>
      </div>
      <div data-name="question_11"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_11 }" class="question-11-collapse collapse">
      <div class="form-group mb-4">
        <dangerous-materials-list :materials="questionnaire.dangerous_materials"></dangerous-materials-list>
        <input id="materials_hidden" name="materials_hidden" type="hidden">
      </div>
      
      
      <div class="form-group mb-4">
        <label for="creti_equipment">
          Mencione el equipo de protección personal que se requiere, o equipo especial (campana de extracción de gases)
        </label>
        <textarea id="creti_equipment"
                  v-model="questionnaire.creti_equipment"
                  class="form-control"
                  cols="50"
                  name="creti_equipment"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="creti_place_frequency_of_disposal">
          Indique el lugar, frecuencia y forma de desecho
        </label>
        <textarea id="creti_place_frequency_of_disposal"
                  v-model="questionnaire.creti_place_frequency_of_disposal"
                  class="form-control"
                  cols="50"
                  name="creti_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>

      


      <div class="form-group mb-4">
        <p>
          ¿Los CRETI serán transportados al Instituto y/o a otro sitio?
        </p>
        <div class="form-check form-check-inline">
          <input id="has-transport-conveyance-radio-1" :checked="questionnaire.has_transfer_conveyance"
                aria-expanded="false"
                class="form-check-input show-collapse collapsed" data-target=".has-transport-conveyance-collapse:not(.show)" data-toggle="collapse"
                name="has_transfer_conveyance"
                type="radio"
                value="1"
                @change="addCustomValidation('has_transfer_conveyance')">
          <label class="form-check-label"
                for="has-transport-conveyance-radio-1">Si</label>
        </div>
        <div class="form-check form-check-inline">
          <input id="has-transport-conveyance-radio-2" :checked="questionnaire.has_transfer_conveyance === false"
                class="form-check-input"
                data-target=".has-transport-conveyance-collapse.show" data-toggle="collapse" name="has_transfer_conveyance"
                type="radio"
                value=""
                @change="removeCustomValidation('has_transfer_conveyance')">
          <label class="form-check-label"
                for="has-transport-conveyance-radio-2">No</label>
        </div>
        <div data-name="has_transfer_conveyance"></div>
      </div>
      
      <div :class="{ 'show': questionnaire.has_transfer_conveyance }" class="has-transport-conveyance-collapse collapse">
        <div class="form-group mb-4">
          <label for="creti_transfer_conveyance">
            Si los CRETI se transportarán al Instituto y/o a otro sitio, indique por qué medio y quién será el
            responsable.
            Especifique periodicidad y horario
          </label>
          <textarea id="creti_transfer_conveyance"
                    v-model="questionnaire.creti_transfer_conveyance"
                    class="form-control"
                    cols="50"
                    name="creti_transfer_conveyance"
                    placeholder="Escriba su respuesta..."
                    rows="5"></textarea>
        </div>
        
        <div class="form-group mb-4">
          <p class="text-muted">
            Nota: Si el sitio donde serán procesadas las muestras y/o generado los desechos es externo al INSP,
            deberá entregarse a la Comisión de Bioseguridad el original de la carta responsiva de la(s) Institución(es)
            colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos (RPBI y CRETI); asimismo
            deberá(n) incorporarse como anexo(s) al SIID
          </p>
          
          <div v-if="questionnaire.creti_letter_path" class="alert alert-warning"
              role="alert">
            Se ha cargado previamente una <strong>
            <a :href="`/${questionnaire.creti_letter_path}`"
              target="_blank">
              Carta responsiva</a></strong>, para cambiar este archivo de click en "Seleccione la carta responsiva"
          </div>
          
          <div class="custom-file">
            <input id="creti_letter"
                  ref="creti_letter"
                  accept="application/pdf"
                  class="custom-file-input"
                  data-id="creti_letter"
                  data-info="creti_letter_info"
                  data-target="creti_letter"
                  data-text="Incorpore la carta responsiva de la(s) Institución(es) colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos."
                  name="creti_letter"
                  type="file"
                  @change="setFile('creti_letter')">
            <label class="custom-file-label" for="creti_letter">Seleccione la carta responsiva</label>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DangerousMaterialsList from './DangerousMaterialsList'
  import { AlertManager } from '../../../utils/AlertManager'
  import autosize from 'autosize'
  
  export default {
    name: 'SectionThree',
    components: {
      DangerousMaterialsList,
    },
    props: {
      questionnaire: Object,
    },
    data: () => ({
      fields: {
        question_11: [
          'creti_equipment',
          'creti_place_frequency_of_disposal',
        ],
      },
      customFields: {
        has_transfer_conveyance: [
          'creti_transfer_conveyance',
          'creti_letter',
        ],
      },
    }),
    methods: {
      addValidation (question) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('add', {
            required: true,
            messages: {
              required: 'Este campo es requerido',
            },
          })
        })
        
        this.questionnaire[question] = true
      },
      removeValidation (question, value = false) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('remove')
        })
        
        this.questionnaire[question] = value

        if (question === 'question_11')  {
          this.questionnaire['has_transfer_conveyance'] = null
        }
      },
      setFile (field) {
        const file = this.$refs[field].files[0]

        if(file.type.indexOf('pdf') === -1) {
          AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
            timeout: 10000,
          })

          $(this.$refs[field]).val('')
          
          return
        }
        
        if (!this.checkFileSize(file)) {
          AlertManager.error(`El tamaño máximo de archivo es de ${ (this.isAdmin() ? 5 : 2) }MB`)
          
          $(this.$refs[field]).val('')

          return
        }
        
        if(!this.checkFileType(file)) {
          AlertManager.error('Seleccione un archivo PDF.')
          
          $(this.$refs[field]).val('')

          return
        }

        this.questionnaire[field] = file
      },
      checkFileSize(file) {
        let maxFileSize = (this.isAdmin() ? 5 : 2) * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
      addCustomValidation (question) {
        const vm = this
        const $formBio = $('.biosecurity-form')
        
        this.customFields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('add', {
            required: function (element) {
              return vm.questionnaire.question_11;
            },
            messages: {
              required: 'Este campo es requerido',
            },
          })
        })
        
        this.questionnaire[question] = true
      },
      removeCustomValidation (question) {
        const $formBio = $('.biosecurity-form')
        
        this.customFields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('remove')
        })
        
        this.questionnaire[question] = false
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    computed: {
      openTabThree () {
        return this.questionnaire.question_3
      },
      ...mapGetters(['user']),
    },
    watch: {
      openTabThree () {
        if (!this.questionnaire.question_3) {
          for (let field in this.fields) {
            if (this.questionnaire[field] === null) {
              this.questionnaire[field] = null
              this.removeValidation(field, null)
            }
          }
        }
      },
    },
    mounted () {
      const vm = this
  
      autosize($('textarea', this.$el))

      $('[name="has_transfer_conveyance"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_11
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
      
      $('[name="materials_hidden"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_11 && vm.questionnaire.dangerous_materials.length < 1
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
    },
  }
</script>
